export const FAVOURITE_UPDATE_REQUESTED = 'FAVOURITE_UPDATE_REQUESTED';
export const FAVOURITE_UPDATE_SUCCEEDED = 'FAVOURITE_UPDATE_SUCCEEDED';
